import React, { useState } from 'react'
import PrivateRoute from '../../components/PrivateRoute'
import { useNavigate } from 'react-router-dom'

import {
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
  Alert,
  LinearProgress,
  Box,
  Switch,
  FormControlLabel
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux'
import { addPlaylist } from '../../actions/playlistActions'

const AddPlaylist = () => {
  const [checked, setChecked] = useState(false)
  const [title, setTitle] = useState('')

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { role } = useSelector(state => state.userState.userInfo)
  const { loading, error } = useSelector(state => state.playlistState)

  const submitHandler = e => {
    e.preventDefault()
    dispatch(addPlaylist(title, checked, navigate))
  }

  return (
    <PrivateRoute>
      <Card sx={{ maxWidth: 650, mt: 5, mx: 'auto' }}>
        {loading && <LinearProgress />}
        <CardContent sx={{ p: 3 }}>
          <Typography gutterBottom variant='h6'>Add Playlist</Typography>
          {error && <Alert severity='error'>{error}</Alert>}
          <form onSubmit={submitHandler}>
            <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
              <Typography sx={{ mr: 1.5 }}>Private</Typography>
              <FormControlLabel
                control={<Switch checked={checked} onChange={e => setChecked(e.target.checked)} />}
                label='Public'
                disabled={role !== 'admin' && role !== 'superadmin'}
              />
            </Box>
            <TextField
              label='Title'
              fullWidth
              sx={{ mb: 2 }}
              name='title'
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
            <Button variant='contained' type='submit' fullWidth sx={{ mt: 1 }}>Submit</Button>
          </form>
        </CardContent>
      </Card>
    </PrivateRoute>
  )
}

export default AddPlaylist